import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import Spotlight from '../components/Spotlight';

const MainLayout = () => {
  const location = useLocation();

  // Spotlight sadece ana sayfalarda gösterilsin
  const showSpotlight = ['/encounters', '/people', '/messages'].includes(location.pathname);

  return (
    <div className="main-layout min-h-screen flex flex-col">
      <Navbar />
      {showSpotlight && (
        <div className="container-fluid">
          <Spotlight />
        </div>
      )}
      <main className="main-content flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default MainLayout;

